import { NavLink } from 'react-router-dom';

const linkClassName = ({ isActive }) => `admin-subtab-btn${isActive ? ' active' : ''}`;

function AdminProjectsSubnav() {
  return (
    <div className="admin-subtabs">
      <NavLink to="/admin-bj/projets" end className={linkClassName}>
        Projets
      </NavLink>
      <NavLink to="/admin-bj/projets/categories" className={linkClassName}>
        Catégories
      </NavLink>
      <NavLink to="/admin-bj/projets/carrousel" className={linkClassName}>
        Carrousel
      </NavLink>
    </div>
  );
}

export default AdminProjectsSubnav;
